import React from "react"
import { useTranslation } from "react-i18next"

import { convertOrderCombosToCartCombos } from "utils"
import classes from "./KtOrderCardCombos.module.scss"

const KtOrderCardCombos = props => {
  const { tableOrder } = props

  const [t] = useTranslation()

  const tableCombos =
    convertOrderCombosToCartCombos(tableOrder.items)

  return (
    tableCombos.map((combo, cIndex) =>
      <div
        key={cIndex}
        className={classes["combo"]}
      >
        <div className={classes["comboNameContainer"]}>
          <div className={classes["comboName"]}>
            {t("بسته_ترکیبی")}{" "}
          </div>
          <div className={classes["comboCode"]}>
            {combo.name}
          </div>
        </div>
        <div>
          {combo.items.map((comboItem, comboItemIndex) =>
            <div
              key={comboItemIndex}
              className={classes["text"]}
            >
              <b>
                {comboItem.quantity} x
              </b>
              <span>
                {" "}{comboItem.foodName}{" "}
              </span>
              <span>
                {!comboItem.isSimple ? `(${comboItem.option.name})` : ""}
              </span>
            </div>
          )}
        </div>
      </div>
    )
  )
}

export default KtOrderCardCombos